/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

export type GetFormDataResponseStatus = typeof GetFormDataResponseStatus[keyof typeof GetFormDataResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFormDataResponseStatus = {
  draft: 'draft',
  published: 'published',
  unpublished: 'unpublished',
  finished: 'finished',
} as const;
